// Klinetix — acordeón de secciones en páginas de política.
// El HTML de cada política viene del cuerpo de la política en Shopify (contenido
// saneado por Shopify: sin <section>/<nav>/id personalizados), así que las
// tarjetas son <div class="klinetix-policy-section"> con un encabezado
// clickeable que revela/oculta su cuerpo, igual que el acordeón de FAQ de
// ficha de producto.
document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.klinetix-policy-section');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var head = section.querySelector('.klinetix-policy-section__head');
    if (!head) return;
    head.addEventListener('click', function () {
      section.classList.toggle('open');
    });
  });
  sections[0].classList.add('open');
});
